class SetUpsell extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('[data-set-upsell-add]');
    this.variantId = this.dataset.variantId;
  }

  connectedCallback() {
    if (!this.button || this.dataset.alreadyInCart === 'true') return;
    this.button.addEventListener('click', this.onAdd.bind(this));
  }

  setLoading(state) {
    this.classList.toggle('is-loading', state);
    if (state) {
      this.button.setAttribute('disabled', 'true');
      this.button.classList.add('btn--loading');
    } else {
      this.button.removeAttribute('disabled');
      this.button.classList.remove('btn--loading');
    }
  }

  async onAdd(event) {
    event.preventDefault();
    if (!this.variantId || !window.FoxTheme) return;

    this.setLoading(true);

    try {
      const addBody = JSON.stringify({
        items: [{ id: parseInt(this.variantId, 10), quantity: 1 }],
      });

      const addResponse = await fetch(FoxTheme.routes.cart_add_url, {
        ...FoxTheme.utils.fetchConfig('javascript'),
        body: addBody,
      });

      const addJson = await addResponse.json();

      if (addJson.status) {
        console.error('Set upsell add error:', addJson.description || addJson.message);
        this.setLoading(false);
        return;
      }

      // On the cart page, re-render in place; elsewhere open the cart drawer.
      const onCartPage = !!document.querySelector('main-cart');
      document.dispatchEvent(
        new CustomEvent('cart:refresh', { detail: { open: !onCartPage } })
      );

      const cartJson = await (
        await fetch(FoxTheme.routes.cart_url, { ...FoxTheme.utils.fetchConfig() })
      ).json();
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
    } catch (err) {
      console.error('Set upsell add failed:', err);
      this.setLoading(false);
    }
  }
}

if (!customElements.get('set-upsell')) {
  customElements.define('set-upsell', SetUpsell);
}
